// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__24cSU","header":"MessagesList_header__bFTtf","chat":"MessagesList_chat__3f4bV"};